module.exports = __webpack_public_path__ + "img/noper.6980ddb4.png";